export { default } from './VocabularyManage';
